import React, { useState } from "react"
import * as common from "./common"
import { green } from "@mui/material/colors"
import ElementText from "./ElementText"
import Svg from "./Svg"
import { useFill } from "./useFill"

const DistributionNetwork = (props) => {
    const { x, y, height, width, label, highlight, highlightColor, fillColor } = props

    const hoverColor = green[200]
    const defaultColor = fillColor || green[100]

    const [fill, setFill] = useState(defaultColor)

    const { handleFill } = useFill({ defaultColor, hoverColor, highlight, highlightColor, setFill })

    return (
        <Svg {...props} defaultColor={defaultColor} hoverColor={hoverColor} setFill={handleFill}>
            <rect
                x={x + 1}
                y={y + 1}
                fill={fill}
                stroke={common.outlineColor}
                width={width - 1}
                height={height - 1}
            />

            <svg x={x + width - 22} y={y - 2}>
                <line x1={2} y1={10} x2={16} y2={10} stroke={common.outlineColor} />
                <line x1={2} y1={14} x2={16} y2={14} stroke={common.outlineColor} />

                <path d={`M5,7 l -5 5 l 5 5`} fill='none' stroke={common.outlineColor} />

                <path d={`M13,7 l 5 5 l -5 5`} fill='none' stroke={common.outlineColor} />
            </svg>

            <ElementText {...props} label={label} />
        </Svg>
    )
}

export default DistributionNetwork
